export default __webpack_public_path__ + "static/media/attendance_mark.dd599964.svg";